import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4e496a64"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=4e496a64&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_css-loader@6.11.0_webpack@5.99.9__lodash@4._a384144eff487845a016474d887108a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports